module.exports = __webpack_public_path__ + "img/nancy-dunn.7bbef3da.jpg";